export default "__VITE_ASSET__4b97e95a__"